
import { StylishSelector } from '@/components/checkboxes/StylishSelector';
import { Camera, PenTool, Origami, Box } from 'lucide-react';
import { AvatarStyle, AvatarStyleType } from './types';

const styleOptions = [
  { id: 'photo', name: 'Photo', icon: Camera },
  { id: 'art', name: 'Art', icon: PenTool },
  { id: 'anime', name: 'Anime', icon: Origami },
  { id: '3d-render', name: '3D', icon: Box }
];

export const AvatarStyleSelector: React.FC<{
  styles: AvatarStyle[];
  selectedStyle: AvatarStyleType;
  onSelectStyle: (style: AvatarStyleType) => void;
}> = ({ styles, selectedStyle, onSelectStyle }) => {
  return (
    <div>
      <div className="mb-3">
        <h3 className="text-sm font-medium mb-1 text-purple-600 dark:text-purple-400">Image Type</h3>
      </div>
      <StylishSelector
        styles={styleOptions}
        selectedStyle={selectedStyle}
        onSelectStyle={onSelectStyle}
        className="grid-cols-2 gap-4"
        colorVariant="purple"
        checkColor="purple-500"
      />
    </div>
  );
};

export default AvatarStyleSelector;
